import { post } from "../../service/api";

const RegisterSettleDirectoryMerchants = async (
  merchantId,
  merchantSettleId,
  accountNumber
) => {
  try {
    return await post(
      `/merchant/${merchantId}/merchantSettle/${merchantSettleId}/vatMerchantDirectory`,
      accountNumber ? { accountNumber } : {}
    );
  } catch (error) {
    console.error("Error RegisterSettleDirectoryMerchants:", error);
    return null;
  }
};

export default RegisterSettleDirectoryMerchants;
